import CertificateFilter from "./certificateFilter";
import ObjectsFilter from "./objectsFilter";
import ObjectsOrdersFilter from "./objectsOrdersFilter";
import Litepicker from "./../litepicker";
import Notify from "./../notify";
import CustomSelect from "./select";
(function($) {
    function deleteParam(prmName) {
        var res = "";

        var d = location.href.split("#")[0].split("?");

        var base = d[0];

        var query = d[1];

        if (query) {
            var params = query.split("&");

            for (var i = 0; i < params.length; i++) {
                var keyval = params[i].split("=");

                if (keyval[0] !== prmName && String(keyval[0]).indexOf(prmName) + 1) {
                    // empty
                } else {
                    res += params[i] + "&";
                }
            }
        }

        window.location.href = base + "?" + res;
    }

    function parseQueryString() {
        //Parsed
        var str = window.location.search;
        var objURL = {};
        str.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function(
            $0,
            $1,
            $2,
            $3
        ) {
            objURL[$1] = $3;
        });
        return objURL;
    }

    function prodPerPage(type, value) {
        var params = parseQueryString();
        params[type] = value;

        var str = "";
        var search = "";
        for (let i in params) {
            if (Array.isArray(params[i])) {
                for (let k in params[i]) {
                    str = i + "[" + k + "]=" + params[i][k];

                    if (decodeURI(search).indexOf(str) + 1) {
                        // empty
                    } else {
                        search += str + "&";
                    }
                }
            } else {
                if (decodeURI(i).indexOf(type) + 1) {
                    // empty
                } else {
                    search += i + "=" + params[i] + "&";
                }
            }
        }

        let url = "?" + search.slice(0, -1);

        return url;
    }

    try {
        var eventButtons = document.getElementById("sort-dataEvents");
        var eventButton = eventButtons.getElementsByTagName("li");

        for (let item of eventButton) {
            item.addEventListener("click", function(e) {
                e.preventDefault();

                let attr = this.getAttribute("data-sort");

                var url = prodPerPage("sort", [attr]);

                window.location.search = url;
            });
        }
    } catch (err) {
        // empty
    }
    // EVENTS PAGINATION
    function preloaderShow() {
        var preloader = document.getElementById("preloader");
        preloader.style.display = "block";
    }

    function preloaderHide() {
        var preloader = document.getElementById("preloader");
        preloader.style.display = "none";
    }

    function loadItems(paginationContainer, containerItems) {
        try {
            var paginationButton = document.getElementById("event-pagination-button");
            var href = paginationButton.getAttribute("href");
            var xhr = new XMLHttpRequest();

            xhr.open("GET", href, false);
            xhr.onload = function() {
                if (xhr.status === 200) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(xhr.responseText, "text/html");

                    var listItemsCollection = doc.getElementsByClassName(
                        "events-list-container"
                    )[0].children;
                    var puginationButtonRequest = doc.getElementById(
                        "event-pagination-button"
                    );

                    paginationButton.remove();

                    try {
                        if (puginationButtonRequest) {
                            paginationContainer.appendChild(puginationButtonRequest);

                            puginationButtonRequest.addEventListener("click", function(e) {
                                e.preventDefault();
                                loadItems(paginationContainer, containerItems);
                            });
                        }
                    } catch (err) {
                        // empty
                        console.log(err);
                    }

                    var items = [];

                    for (let item of listItemsCollection) {
                        items.push(item);
                    }

                    items.forEach(function(item) {
                        containerItems[0].appendChild(item);
                    });
                }
            };
            xhr.onloadstart = function() {
                preloaderShow();
            };
            xhr.onloadend = function() {
                preloaderHide();
            };

            xhr.send();
        } catch (err) {
            // empty
        }
    }

    try {
        var paginationContainer = document.getElementById("events-pagination");
        var paginationButton = document.getElementById("event-pagination-button");
        var containerItems = document.getElementsByClassName(
            "events-list-container"
        );

        paginationButton.addEventListener("click", function(e) {
            e.preventDefault();
            loadItems(paginationContainer, containerItems);
        });

        var lastElement =
            containerItems[0].children[containerItems[0].children.length - 1];

        if (isVisible(lastElement)) {
            loadItems(paginationContainer, containerItems);
        }

        window.addEventListener("scroll", function() {
            var lastElement =
                containerItems[0].children[containerItems[0].children.length - 1];

            if (isVisible(lastElement)) {
                loadItems(paginationContainer, containerItems);
            }
        });


        setTimeout(function() {

            loadItems(paginationContainer, containerItems);
        }, 100)




    } catch (err) {
        // empty
    }

    function isVisible(element) {
        var w = window;
        var wt = w.pageYOffset;
        var lt = element.offsetTop;
        var lb = lt + element.clientHeight;
        return lb <= wt + w.innerHeight && lt >= wt;
    }

    // EVENTS PAGINATION END

    // SESSIONS FILTER
    try {
        var status = document.getElementById("select-status");

        status.addEventListener("change", function() {
            var value = status.value;
            var url = prodPerPage("status", [value]);
            window.location.search = url;
        });
    } catch (err) {
        // empty
    }
    // SORT SESSIONS DATE
    try {
        var sort = document.getElementById("select-sort");

        sort.addEventListener("change", function() {
            var value = sort.value;
            var url = prodPerPage("sort", [value]);
            window.location.search = url;
        });
    } catch (err) {
        // empty
    }
    // SESSION DATERANGEPICKER

    try {
        new Litepicker({
            element: document.getElementById("data-daterangepicker-session"),
            lang: "ru-RU",
            format: "D MM, YYYY",
            // selectedDaysFormat: "YYYY-MMM-D",
            singleMode: false,
            numberOfMonths: 2,
            numberOfColumns: 2,
            onSelect: function(date1, date2) {
                var year1 = new Date(date1).getFullYear();
                var day1 = new Date(date1).getDate();
                var mounth1 = new Date(date1).getMonth() + 1;

                if (mounth1 <= 9) {
                    mounth1 = "0" + mounth1;
                }
                if (day1 <= 9) {
                    day1 = "0" + day1;
                }

                var resultDate1 = year1 + "-" + mounth1 + "-" + day1;

                var year2 = new Date(date2).getFullYear();
                var day2 = new Date(date2).getDate();
                var mounth2 = new Date(date2).getMonth() + 1;

                if (mounth2 <= 9) {
                    mounth2 = "0" + mounth2;
                }
                if (day2 <= 9) {
                    day2 = "0" + day2;
                }

                var resultDate2 = year2 + "-" + mounth2 + "-" + day2;

                var url = prodPerPage("dat", [resultDate1, resultDate2]);

                window.location.search = url;
            },
        });

        document
            .getElementById("date-daterangepicker-session-reset")
            .addEventListener("click", function() {
                deleteParam("dat");
            });
    } catch (err) {
        // empty
    }

    $(".copy-pay-link").on("click", function(e) {
        e.preventDefault();
        let text = $("#copy-pay-link").text();
        navigator.clipboard
            .writeText(text)
            .then(() => {
                new Notify("Прямая ссылка на форму успешно скопирована", "success");
            })
            .catch((error) => {
                new Notify(`Ошибка  копирования! ${error}`, "alert");
            });
    });

    $(".copy-button").on("click", function(e) {
        e.preventDefault();
        let text = $("#copy-button").text();
        navigator.clipboard
            .writeText(text)
            .then(() => {
                new Notify("Код для кнопки успешно скопирован", "success");
            })
            .catch((error) => {
                new Notify(`Ошибка  копирования! ${error}`, "alert");
            });
    });

    $(".copy-script").on("click", function(e) {
        e.preventDefault();
        let text = $("#copy-script").text();
        navigator.clipboard
            .writeText(text)
            .then(() => {
                new Notify("Скрипт для кнопки успешно скопирован", "success");
            })
            .catch((error) => {
                new Notify(`Ошибка  копирования! ${error}`, "alert");
            });
    });

    // $(document).on("click", ".card-object-link", function(e) {
    //     e.preventDefault();
    //     document.location.href = $(this).attr("data-href")
    // });

    const filter = new CertificateFilter();
    filter.init();

    const objectFilter = new ObjectsFilter();
    objectFilter.init();

    const objectsOrdersFilter = new ObjectsOrdersFilter();
    objectsOrdersFilter.init();


    if ($("#select-object").length) {
        const select1 = new CustomSelect('#select-object');
    }






})(jQuery);
//